import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';

import HeaderContainer from '../containers/HeaderContainer';
import OverviewContainer from '../containers/OverviewContainer';
import ConfiguratorContainer from '../containers/ConfiguratorContainer';
import CheckoutContainer from '../containers/CheckoutContainer';
import IntroductionLayerContainer from '../containers/IntroductionLayerContainer';
import StaticPenContainer from '../containers/StaticPenContainer';

import LocaleText from './LocaleText';
import Home from './Home';
import NotFound from './NotFound';
import ImprintContent from './ImprintContent';
import DataPrivacyContent from './DataPrivacyContent';

import Sidemenu from '../components/Sidemenu';
import FullScreenPopup from '../components/FullScreenPopup';

import { hasSubdomain, getSubdomain } from '../helpers/utilityHelpers';

import API from '../API';
import Loader from './Loader';
import BrowserDetectPopUp from './BrowserDetectPopUp/BrowserDetectPopUp';
import BrowserDetectContent from './BrowserDetectContent';

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.validLocales = ['de', 'en', 'fr', 'ru'];
        this.setLocaleAndTexts = this.setLocaleAndTexts.bind(this);
        this.isValidLocale = this.isValidLocale.bind(this);
        this.onLanguageSelect = this.onLanguageSelect.bind(this);
        this.langUrl = this.langUrl.bind(this);
        this.renderLanguageMenuItems = this.renderLanguageMenuItems.bind(this);

        if (hasSubdomain(window.location.host)) {
            const dealer = getSubdomain(window.location.host);
            // get dealer info
            API.getDealerInfo(dealer)
                .then(res => {
                    this.props.setDealer({ ...res.data.data, slug: dealer });
                })
                .catch(err => {
                    if (err.response.status !== 404) {
                        console.error(err.message);
                    }
                });
        }
    }

    componentWillMount() {
        this.setLocaleAndTexts().then(() => {
            this.props.setIsLoading(false);
        });
    }

    componentWillUpdate(nextProps) {
        const nextLang = nextProps.match.params.lang;
        const currentLang = this.props.match.params.lang;
        if (nextLang !== currentLang) {
            this.props.setIsLoading(true);
            this.setLocaleAndTexts(nextLang).then(() => this.props.setIsLoading(false));
        }
    }

    isValidLocale(locale) {
        return this.validLocales.includes(locale);
    }

    setLocaleAndTexts(lang = null) {
        return new Promise((resolve, reject) => {
            if (!lang) {
                lang = this.props.match.params.lang;
            }

            if (!this.isValidLocale(lang)) {
                lang = 'de';
            }

            this.props.setLocale(lang);

            API.getTexts().then(response => {
                this.props.setLocaleTexts(response.data.data);
                resolve();
            });
        });
    }

    langUrl(locale) {
        let currentUrl = this.props.location.pathname;
        return `/${locale}` + currentUrl.slice(3);
    }

    onLanguageSelect(locale) {
        this.props.setLocale(locale);
        this.props.toggleLanguageMenu();
    }

    renderLanguageMenuItems() {
        const currentLang = this.props.match.params.lang;

        // TODO localize these
        const langs = {
            de: 'German',
            fr: 'French',
            en: 'English',
            ru: 'Russian',
        };

        return Object.keys(langs).map(key => {
            const classes = ['menu__item'];
            let activeIcon = null;
            if (key === currentLang) {
                classes.push('menu__item--active');
                activeIcon = <Isvg src="/svg/check-bold-mini.svg" />;
            }
            return (
                <li className={classes.join(' ')} key={key}>
                    <Link to={this.langUrl(key)} onClick={() => this.onLanguageSelect(key)}>
                        {langs[key]}
                        {activeIcon}
                    </Link>
                </li>
            );
        });
    }

    render() {
        const lang = this.props.match.params.lang;
        if (!this.isValidLocale(lang)) {
            return <Redirect to="/404" />;
        }

        const {
            dealer,
            toggleSideMenu,
            toggleLanguageMenu,
            toggleImprintPopup,
            toggleDataPrivacyPopup,
            toggleBrowserDetectPopup,
            isLanguageMenuOpen,
            isSideMenuOpen,
            isImprintPopupOpen,
            isDataPrivacyPopupOpen,
            isBrowserDetectPopupOpen,
            isLoading,
        } = this.props;

        return (
            <div className={`layout layout--${lang}`}>
                <HeaderContainer
                    sideMenuToggle={toggleSideMenu}
                    toggleLanguageMenu={toggleLanguageMenu}
                    lang={lang}
                    dealer={dealer}
                    isLoading={isLoading}
                    languages={this.validLocales}
                />

                {isLoading && <Loader />}

                {!isLoading && (
                    <div>
                        <Sidemenu toggle={toggleSideMenu} isOpen={isSideMenuOpen}>
                            <div className="menu-items">
                                {dealer ? null : (
                                    <a href={this.props.sidemenuLinks.contact} target="_blank">
                                        <LocaleText textKey="sidemenu.contact.title" />
                                    </a>
                                )}
                                <a href={this.props.sidemenuLinks.faq} target="_blank">
                                    <LocaleText textKey="sidemenu.faq.title" />
                                </a>
                                <p
                                    onClick={() => {
                                        toggleImprintPopup();
                                        toggleSideMenu();
                                    }}
                                >
                                    <LocaleText textKey="sidemenu.imprint.title" />
                                </p>
                                <p
                                    onClick={() => {
                                        toggleDataPrivacyPopup();
                                        toggleSideMenu();
                                    }}
                                >
                                    <LocaleText textKey="sidemenu.data.privacy.title" />
                                </p>
                                <p
                                    onClick={e => {
                                        e.preventDefault();
                                        console.log('User Centrics Layer');
                                        if (
                                            typeof UC_UI !== 'undefined' &&
                                            typeof UC_UI.showSecondLayer === 'function'
                                        ) {
                                            UC_UI.showSecondLayer();
                                        } else {
                                            console.warn('Usercentrics Layer not available');
                                        }
                                    }}
                                >
                                    <LocaleText textKey="sidemenu.data.cookies.title" />
                                </p>
                            </div>
                        </Sidemenu>

                        <FullScreenPopup
                            toggle={toggleLanguageMenu}
                            isOpen={isLanguageMenuOpen}
                            extraClasses={['language-menu']}
                        >
                            <div className="language-menu-items">
                                <h2>
                                    <LocaleText textKey="language.menu.title" />
                                </h2>

                                <ul className="menu">{this.renderLanguageMenuItems()}</ul>
                            </div>
                        </FullScreenPopup>

                        <FullScreenPopup
                            isOpen={isImprintPopupOpen}
                            toggle={toggleImprintPopup}
                            extraClasses={['legal-content']}
                        >
                            <ImprintContent dealer={dealer} />
                        </FullScreenPopup>

                        <FullScreenPopup
                            isOpen={isDataPrivacyPopupOpen}
                            toggle={toggleDataPrivacyPopup}
                            extraClasses={['legal-content']}
                        >
                            <DataPrivacyContent />
                        </FullScreenPopup>

                        <BrowserDetectPopUp
                            isOpen={isBrowserDetectPopupOpen}
                            toggle={toggleBrowserDetectPopup}
                        >
                            <BrowserDetectContent />
                        </BrowserDetectPopUp>

                        <IntroductionLayerContainer />
                    </div>
                )}

                <div id="main">
                    {!isLoading && (
                        <Switch>
                            <Route exact path={`/:lang([a-z]{2})`} component={Home} />
                            <Route
                                exact
                                path={`/:lang([a-z]{2})/pens`}
                                component={OverviewContainer}
                            />
                            <Route
                                exact
                                path={`/:lang([a-z]{2})/static-pen/:pen`}
                                component={StaticPenContainer}
                            />
                            <Route
                                exact
                                path={`/:lang([a-z]{2})/pen/:pen`}
                                component={ConfiguratorContainer}
                            />
                            <Route
                                exact
                                path={`/:lang([a-z]{2})/checkout`}
                                component={CheckoutContainer}
                            />
                            <Route path={`/:lang([a-z]{2})/*`} component={NotFound} />
                        </Switch>
                    )}
                </div>
            </div>
        );
    }
}

Layout.propTypes = {};

Layout.defaultProps = {};

export default Layout;
